import React, { memo, useState } from 'react';

import SettingsCard from '../SettingsCard/SettingsCard';

import './style.scss';

import { toastr } from 'react-redux-toastr';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { IaCreators } from '../../../../../store/actions/intelligence';
import editImg from '../../../img/edit-aprimoramento.svg';
import { UserActions } from '../../../../../store/actions/users';

function Card(props) {
  const { user } = props;
  const [selectedPart, setSelectedPart] = useState('');
  const [mousePos, setMousePos] = useState(null);

  const exitEditingCard = () => {
    props.setSelectedMessage(null);
  };

  const ignoreCard = async () => {
    const { bot, message } = props;

    if (!(message && message._id)) {
      toastr.error('Ops', 'Não foi possível ignorar este card');
      return false;
    }
    await props.ignoreCurationMessage(bot._id, message._id);
    props.listCurationMessages(
      props.bot._id,
      10,
      props.filterCuration.query,
      '',
      props.filterCuration.status,
      props.filterCuration.start_date,
      props.filterCuration.end_date
    );
  };

  const getSelectionRange = () => {
    if (document.selection) return document.selection.createRange();

    const selection = window.getSelection();
    if (!selection.rangeCount) return false;

    return selection.getRangeAt(0);
  };

  const selectMessageArea = (e) => {
    e.persist();
    if (!props.selectedMessage) return;

    const range = getSelectionRange();
    if (!range) {
      return setSelectedPart('');
    }
    const text = range.toString();
    if (!text.length) {
      return setSelectedPart('');
    }
    setSelectedPart(
      props.selectedMessage.message.substring(
        range.startOffset,
        range.endOffset
      )
    );
    setMousePos({ x: e.clientX, y: e.clientY });
  };

  const handleVoltar = () => {
    exitEditingCard();
    props.clearAprimoramentos();
  };

  const handleSalvar = () => {
    props.saveAprimoramentos(props.aprimoramentos, {
      bot: props.bot._id,
      message: props.message._id,
      callback: () => handleVoltar(),
    });
  };

  return (
    <>
      <div
        onDoubleClickCapture={
          user?.selectedCompany?.claim?.name !== 'Viewer'
            ? () => setSelectedPart('')
            : ''
        }
      >
        <div className="container-display">
          <div
            className="display-enhancement"
            onMouseUpCapture={
              user?.selectedCompany?.claim?.name !== 'Viewer'
                ? (e) => selectMessageArea(e)
                : ''
            }
          >
            <span>{props.message.message}</span>
          </div>
          {(props.selectedMessage && (
            <div style={{ marginRight: 20, cursor: 'pointer' }}>
              <span
                style={{
                  color: '#0D84FF',
                  marginRight: 15,
                  fontWeight: 800,
                  fontSize: '14px',
                }}
                onClick={
                  user?.selectedCompany?.claim?.name !== 'Viewer'
                    ? handleSalvar
                    : ''
                }
              >
                salvar
              </span>
              <span style={{ color: '#858F9E' }} onClick={handleVoltar}>
                voltar
              </span>
            </div>
          )) || (
            <div
              style={{
                marginRight: 20,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <img src={editImg} style={{ marginRight: 5, fontWeight: 800 }} />
              <span
                style={{
                  color: '#515F75',
                  marginRight: 20,
                  fontWeight: 800,
                  fontSize: '14px',
                }}
                onClick={
                  user?.selectedCompany?.claim?.name !== 'Viewer'
                    ? () => props.setSelectedMessage(props.message)
                    : ''
                }
              >
                aprimorar
              </span>
              <span
                style={{ color: '#858F9E' }}
                onClick={
                  user?.selectedCompany?.claim?.name !== 'Viewer'
                    ? () => ignoreCard()
                    : ''
                }
              >
                ignorar
              </span>
            </div>
          )}
        </div>
      </div>
      {selectedPart && (
        <SettingsCard
          user={user}
          mousePos={mousePos}
          selectedPart={selectedPart}
          setSelectedPard={setSelectedPart}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  aprimoramentos: state.intelligence.aprimoramentos,
  filterCuration: state.intelligence.filterCuration,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...IaCreators,
      ...UserActions,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(memo(Card)));
